export const StoreFilter = {
  title: 'Pesquisa por Loja',
  multiSelectTitle: 'Pesquisa por Loja ({items})'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/StoreFilter.js